import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { PbIconModule } from "@pb/theme";

@Component({
	selector: "ppf-root",
	standalone: true,
	imports: [RouterOutlet, PbIconModule],
	templateUrl: "./app.component.html",
	styleUrl: "./app.component.scss",
})
export class AppComponent {}
